import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import IconButton from '@mui/material/IconButton';
import { useCallback } from 'react';
import { addMessageBox } from '../../redux/actions/messageBoxesActions';
import { useAppDispatch } from '../../redux/store';
import { isExternalUrl, openUrl } from '../../utils/urlUtils';
const MAX_NUM_URL_CHARS = 40;
const CONTAINER_CSS = css `
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 5px;
  font-size: 80%;
  padding: 2px 4px;
  overflow-wrap: break-word; // allow breaking anywhere to avoid horizontal scrollbar
`;
export const HtmlAreaExternalLinkButton = ({ url }) => {
    const dispatch = useAppDispatch();
    const onClick = useCallback(() => {
        if (isExternalUrl(url, window.location.href)) {
            dispatch(addMessageBox({ type: 'external-link', url }));
        }
        else {
            openUrl(url);
        }
    }, [dispatch, url]);
    const urlText = url.length > MAX_NUM_URL_CHARS ? `${url.substring(0, MAX_NUM_URL_CHARS)}…` : url;
    return (_jsxs("span", { css: CONTAINER_CSS, children: [urlText, _jsx(IconButton, { onClick: onClick, size: 'small', title: 'Open Link', children: _jsx(LaunchRoundedIcon, {}) })] }));
};
